const appEnv = (import.meta.env['VITE_APP_ENV'] ?? 'dev');
if (!['dev', 'stg', 'prod'].includes(appEnv)) {
    throw new Error(`Invalid VITE_APP_ENV: "${appEnv}". Must be dev | stg | prod`);
}
const apiBaseUrls = {
    dev: 'https://dev-api.acie.skin',
    stg: 'https://stg-api.acie.skin',
    prod: 'https://api.acie.skin',
};
export const config = {
    appEnv,
    apiBaseUrl: apiBaseUrls[appEnv],
    isDevelopment: import.meta.env.DEV,
    isProduction: import.meta.env.PROD,
};
